import { Injectable } from '@angular/core';
import { MessageNotificationService } from 'message-notification-service-lib';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BullhornDataService } from './bullhorn-data.service';

@Injectable({
  providedIn: 'root',
})
export class SaveNoteService {
  constructor(
    private bullhornDataService: BullhornDataService,
    private messageNotificationService: MessageNotificationService
  ) {}

  saveNote(
    putData: string,
    successMessage?: string,
    errorMessage?: string,
    noteId?: string,
  ): Observable<string | null> {
    return this.bullhornDataService.createNote(putData, noteId).pipe(
      // todo change type and just check in general
      map((response: any) => {
        if (response && response.error) {
          console.log(response);
          if ((errorMessage) && (errorMessage.length > 0)) {
            this.messageNotificationService.error(errorMessage, response.error.errorMessage);
          }
          return null;
        } else {
          if (successMessage && successMessage.length > 0) {
            this.messageNotificationService.success(successMessage);
          }
          return response?.data?.changedEntityId || noteId || null;
        }
      }),
      catchError((e) => {
        console.log(e);
        this.messageNotificationService.error(errorMessage, e.message);
        return of(null);
      })
    );
  }

}
